module.exports = ngModule => {
  ngModule.constant(
    'formlyErrorAndWarningsUrlPrefix',
    `https://github.com/formly-js/angular-formly/blob/${VERSION}/other/ERRORS_AND_WARNINGS.md#`
  );
};



/** WEBPACK FOOTER **
 ** ../~/jshint-loader!./providers/formlyErrorAndWarningsUrlPrefix.js
 **/